import { APIModel } from "./api-model";

export class TransplantCenter extends APIModel {
  id!: string;
  name!: string;
  code!: string;

  static fieldsToMap = {
    direct: [
      'id',
      'code',
      'name'
    ]
  }

  static buildFromAPI(record: any): TransplantCenter {
    const transplantCenter = new TransplantCenter();
    record = record || {};

    this.mapFieldsDirectly<TransplantCenter>(TransplantCenter.fieldsToMap.direct, record, transplantCenter);

    return transplantCenter;
  }
}